import React from 'react';
import { connect } from 'react-redux'
import { branch, compose, renderComponent } from 'recompose'
import { sessionActions, sessionSelectors } from './redux'
import LogInDialog from "./LogInDialog";
import Loading from '../../components/Loading'

const mapStateToProps = (state) => ({
    isLoggingIn: sessionSelectors.loggingIn(state),
    loginErrorMessage: sessionSelectors.loginErrorMessage(state),
});

const mapDispatchToProps = (dispatch) => ({
    onForgotClicked: (email) => dispatch(sessionActions.forgotPassword(email)),
    onLogInClicked: (username, password) => dispatch(sessionActions.logIn(username, password)),
    onCancelClicked: () => dispatch(sessionActions.cancelLoginDialog()),
});

export default compose (
    connect(mapStateToProps, mapDispatchToProps),
    branch(({isLoggingIn}) => isLoggingIn,
        renderComponent(()=><Loading title={'Loggar in...'}/>)
    )
)(LogInDialog)